import { useMemo } from 'react';
import {
  FieldPath,
  FieldValues,
  FieldErrors,
  get,
  useFormState,
} from 'react-hook-form';
import {
  getMessages,
  isFieldError,
  ValidationMessage,
} from '../../../utils/ValidationMessagesMap';

export const useFormInputMessages = <
  FormData extends FieldValues,
  Name extends FieldPath<FormData>
>(
  name: Name
): ValidationMessage[] => {
  const { errors } = useFormState<FormData>({
    name, // does not seem to have any effect but ok, maybe in future versions it will have
  });
  const fieldError: FieldErrors<FormData>[Name] = useMemo(
    () => get(errors, name),
    [errors, name]
  );

  return useMemo(
    () => (isFieldError(fieldError) ? getMessages(fieldError) : []),
    [fieldError]
  );
};
